import {Stage} from "src/constants/common";
import {STAGE_NAME} from "src/constants/appConfig";

/*
 * Standalone application entry.
 *
 * Evaluating this module mounts the application, so nothing in the federated
 * ./MLEApp subgraph may import from it. STAGE_NAME and MLE_ROUTES live in
 * src/constants/appConfig so that importing either cannot reach the mount below;
 * see the comment there for what happens when they do.
 */

// skip loading react in testing for now. So that proper unit tests can exist cleanly and without excessive load time
// TODO: continue https://taskei.amazon.dev/tasks/V1334014338 and determine a way to use RTL
//  for testing without disabling the ability to test non-visible requirements
if(!global.skipRTL){
    console.log("Stage name " + STAGE_NAME);

    //Sets the right stage based CDN URL for FAB to be consumed via Module Federation.
    // @ts-ignore
    if (STAGE_NAME.toLowerCase() === Stage.prod) {
        (window as any).FAB_URL = 'https://atoz.amazon.work/assets/MyHRLiveHelpModuleWebsite';
    } else {
        (window as any).FAB_URL = 'https://atoz.integ.amazon.com/assets/MyHRLiveHelpModuleWebsite';
    }

    import('./bootstrap');
}
